module.exports = __webpack_public_path__ + "static/media/Done-1.b71700f6.png";